const initialState = { open: false, errors: {}, body: '', hasErrors: true };
export default initialState;
